/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathLower = createReactComponent("math-lower", "IconMathLower", [
  ["path", { d: "M19 18l-14 -6l14 -6", key: "svg-0" }]
]);

export { IconMathLower as default };
//# sourceMappingURL=IconMathLower.js.map
